
import './App.css';
import './APP/routes/index'

import AppRoutes from './APP/routes/index';

function App() {
  return (
   <>

      <AppRoutes/>
   </>
  );
}

export default App;
